<header style="
  width: 100%;
  z-index: 2;">
  <div class="navbar navbar-dark bg-dark box-shadow">
    <div class="container-fluid d-flex justify-content-between">
      <div class="d-flex align-items-center brand-container">
        <div class="left-brand d-flex align-items-center">
          <a routerLink="/" class="navbar-brand d-flex align-items-center" *ngIf="authService.showlogin">
            <img src="assets/images/AF_MovProsAlarmas_Logo_RGB_NEG_2.svg" alt="">
            {{ title }}
          </a>
          <a class="navbar-brand d-flex align-items-center" *ngIf="!authService.showlogin">
            <img src="assets/images/AF_MovProsAlarmas_Logo_RGB_NEG_2.svg" alt="">
          </a>

          <!-- Desktop-only: show the ClubMPA logo inline on desktop, not clickable -->
          <img class="club-logo desktop-only" src="assets/images/ClubMPA.png" alt="Club MPA">
        </div>

        <!-- Centro: logo independiente, siempre centrado en el header. No es un botón/enlace. -->
        <div class="center-logo" style="display: none;" aria-hidden="true">
          <img class="club-logo" src="assets/images/ClubMPA.png" alt="Club MPA">
        </div>
      </div>
      <!-- <div class="col-12 col-md-9" style="display: flex; justify-content: center;" *ngIf="isAuthenticated">
        <div class="col-12 col-md-12 d-flex flex-column align-items-center mt-2" style="max-width: 100%;">
          <div class="border-banner mb-2 text-center" style="color: rgb(252 201 0)">
            <mat-icon class="icon-banner" mat-list-icon>announcement</mat-icon>&nbsp;&nbsp;&nbsp;
            <strong>A partir del día 1 de julio de 2025, vamos a deshabilitar el acceso al Portal Partners a todos los usuarios inactivos que no accedan durante un período de 40 días. <br>
              En el caso de los representantes, el plazo será de 60 días para deshabilitar el acceso.
 </strong>
          </div>
        </div>
      </div> -->
      <nav *ngIf="!isAuthenticated" class="mr-md-3 d-flex align-items-center">
        <!-- <a class="p-2 text-light" routerLink="/register">Signup</a>  -->
        <!-- <a class="p-2 text-light" routerLink="/login">Login</a> -->

        <button mat-raised-button color="warn" (click)="login()" *ngIf="authService.showlogin"><i
            class="fas fa-sign-in-alt" aria-hidden="true"></i> Login</button>
      </nav>
      <nav *ngIf="isAuthenticated" class="mr-md-3 d-flex align-items-center">
        <div class="row">
          <div class="col" *ngIf="showPasswordExpiryWarning">
            <i *ngIf="passwordExpiryDays < 5" class="mat-icon"
              matTooltip="Su contraseña está a punto de caducar, por favor pinche aquí para cambiarla"
              matTooltipPosition="above" [matTooltipClass]="'password-expiry-tooltip'"
              (click)="redirectToChangePassword()" style="cursor: pointer; color: orange; font-size: 24px;">
              <mat-icon>warning</mat-icon>
            </i>
          </div>
          <!-- <div>
            <svg class="bell-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                fill="currentColor" />
            </svg>
          </div> -->
          <div class="header-user-menu" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="header-user-trigger"
              (click)="toggleUserMenu($event)"
              title="Usuario"
              aria-label="Abrir menú de usuario"
              aria-haspopup="menu"
              [attr.aria-expanded]="isUserMenuOpen"
            >
              <i class="far fa-user-circle text-light" aria-hidden="true"></i>
            </button>

            <div *ngIf="isUserMenuOpen" class="header-user-dropdown" role="menu" aria-label="Menú de usuario">
              <div class="header-user-name" role="presentation" [title]="authService.name">
                {{ authService.name }}
              </div>
              <button
                type="button"
                class="header-user-logout"
                role="menuitem"
                (click)="signout()"
                title="Cerrar sesión"
                aria-label="Cerrar sesión"
              >
                <mat-icon>logout</mat-icon>
                <span>Cerrar sesión</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</header>